import * as React from 'react';

// tslint:disable-next-line:import-name match-default-export-name
import LogoSVG from '../../images/logo/Logo';

const Logo: React.FunctionComponent<React.HTMLAttributes<SVGElement>> = ({
  role = 'img',
  ...props
}) => <LogoSVG focusable='false' {...props} role={role} />;

Logo.displayName = 'Logo';

export default Logo;
